/*const mapaUnidades = () => { 
  const selectedText = document.getElementById("selected-text");
  const optionsList = document.getElementById("custom-options");
  const estados = document.querySelectorAll(".estado");
  const statesRight = document.querySelectorAll(".ul-states li");
  const remotoButton = document.getElementById("remoto");
  const presencialButton = document.getElementById("presenciais");
  const cards = document.querySelectorAll("[data-tipo]");

  const corRemoto = "#696969";
  const corPresencial = "#ccab78";

  const aplicarEstilosPadrao = () => {
    estados.forEach((estado) => {
      const tipo = estado.dataset.tipo?.toLowerCase();
      estado.style.strokeWidth = "1.5px";
      estado.style.fill =
        tipo === "remoto"
          ? corRemoto
          : tipo === "presencial"
          ? corPresencial
          : "#000000";
      estado.style.display = "inline";
      estado.style.visibility = "visible";
      estado.style.opacity = "1";
    });
  };

  const atualizarStroke = (estado) => {
    if (estado.classList.contains("selected")) {
      estado.style.stroke = "#000000";
    } else {
      estado.style.stroke = "#ffffff";
    }
  };

  const aplicarFiltro = (tipoSelecionado) => {
    estados.forEach((estado) => {
      const tipo = estado.dataset.tipo?.toLowerCase();

      if (tipoSelecionado === "todos") {
        estado.classList.remove("selected");

        // Adiciona "selected" apenas se for remoto ou presencial
        if (tipo === "remoto" || tipo === "presencial") {
          estado.classList.add("selected");
        }
      } else if (tipo === tipoSelecionado) {
        estado.classList.add("selected");
      } else {
        estado.classList.remove("selected");
      }

      // Define fill
      if (tipoSelecionado === "todos") {
        estado.style.fill =
          tipo === "remoto"
            ? corRemoto
            : tipo === "presencial"
            ? corPresencial
            : "#000000";
      } else if (tipo === tipoSelecionado) {
        estado.style.fill =
          tipoSelecionado === "remoto" ? corRemoto : corPresencial;
      } else {
        estado.style.fill = "#000000";
      }

      atualizarStroke(estado);

      estado.style.strokeWidth = "1.5px";
      estado.style.display = "inline";
      estado.style.visibility = "visible";
      estado.style.opacity = "1";
    });

    cards.forEach((card) => {
      const tipoCard = card.dataset.tipo?.toLowerCase();
      if (tipoSelecionado === "todos" || tipoCard === tipoSelecionado) {
        card.classList.remove("hidden");
      } else {
        card.classList.add("hidden");
      }
    });
  };


  if (!selectedText || !optionsList) return;

  selectedText.addEventListener("click", () => {
    optionsList.classList.toggle("hidden");
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest("[js-select-wrapper]")) {
      optionsList.classList.add("hidden");
    }
  });


  const ajustarStrokeSePreto = (estado) => {
    const strokeComputed = getComputedStyle(estado).stroke;
    const strokeAttr = estado.getAttribute("stroke");

    const isStrokePretoCSS = strokeComputed === "rgb(0, 0, 0)";
    const isStrokePretoAttr = strokeAttr === "black";

    if (isStrokePretoCSS || isStrokePretoAttr) {
      estado.style.stroke = "rgba(255, 255, 255, 0.5)";
      estado.style.strokeWidth = "1px";
    }
  };

  const aplicarEstilosEstados = (tipoSelecionado) => {
    estados.forEach((estado) => {
      const tipo = estado.dataset.tipo?.toLowerCase();

      // Força correção se tiver stroke preto
      ajustarStrokeSePreto(estado);

      if (tipoSelecionado === "todos" || !tipoSelecionado) {
        estado.style.opacity = "1";
        estado.style.stroke = "";
        estado.style.strokeWidth = "";
      } else if (tipo === tipoSelecionado) {
        estado.style.opacity = "1";
        estado.style.stroke = "";
        estado.style.strokeWidth = "";
      } else {
        estado.style.opacity = "1";
        estado.style.stroke = "rgba(255, 255, 255, 0.5)";
        estado.style.strokeWidth = "1px";
      }
    });
  };

  const aplicarFiltroCards = (tipoSelecionado) => {
    cards.forEach((card) => {
      const tipoCard = card.dataset.tipo?.toLowerCase();
      if (tipoSelecionado === "todos" || !tipoSelecionado) {
        card.classList.remove("hidden");
      } else if (tipoCard === tipoSelecionado) {
        card.classList.remove("hidden");
      } else {
        card.classList.add("hidden");
      }
    });
  };

  optionsList.querySelectorAll("li").forEach((item) => {
    item.addEventListener("click", () => {
      const valor = item.dataset.value.toLowerCase();
      const label = selectedText.querySelector("p");
      if (label) label.textContent = item.textContent.trim();
      optionsList.classList.add("hidden");

      aplicarFiltro(valor);
    });
  });

  estados.forEach((estado) => {
    estado.addEventListener("click", () => {
      estado.classList.toggle("selected");
      atualizarStroke(estado);

      aplicarEstilosEstados(valor);
      aplicarFiltroCards(valor);
    });
  });

  const changeStates = () => {
    estados.forEach((estado) => {
      estado.addEventListener("mouseenter", () => {
        estado.classList.add("active");

        statesRight.forEach((e) => {
          if (e.dataset.liEstado === estado.dataset.idEstado) {
            e.querySelector("p")?.classList.add("text-active");
            const svg = e.querySelector("svg");
            if (svg) {
              svg.classList.remove("opacity-0");
              svg.classList.add("opacity-1");
            }
          }
        });
      });

      estado.addEventListener("mouseleave", () => {
        estado.classList.remove("active");

        statesRight.forEach((e) => {
          e.querySelector("p")?.classList.remove("text-active");
          const svg = e.querySelector("svg");
          if (svg) svg.classList.add("opacity-0");
        });
      });
    });
  };

  const changeStatesActive = () => {
    statesRight.forEach((li) => {
      li.addEventListener("click", () => {
        statesRight.forEach((i) => {
          i.querySelector("p")?.classList.remove("text-active");
          i.querySelector("svg")?.classList.add("opacity-0");
        });

        li.querySelector("p")?.classList.add("text-active");
        li.querySelector("svg")?.classList.remove("opacity-0");
        li.querySelector("svg")?.classList.add("opacity-1");

        estados.forEach((e) => {
          if (li.dataset.liEstado === e.dataset.idEstado) {
            e.classList.add("active");
          } else {
            e.classList.remove("active");
          }
        });
      });
    });
  };

  if (remotoButton) {
    remotoButton.addEventListener("click", () => aplicarFiltro("remoto"));
  }

  if (presencialButton) {
    presencialButton.addEventListener("click", () => aplicarFiltro("presencial"));
  }
  remotoButton?.addEventListener("click", () => {
    aplicarEstilosEstados("remoto");
    aplicarFiltroCards("remoto");
  });

  presencialButton?.addEventListener("click", () => {
    aplicarEstilosEstados("presencial");
    aplicarFiltroCards("presencial");
  });

  aplicarEstilosPadrao();
  aplicarFiltro("todos");
  changeStates();
  changeStatesActive();
};

export default mapaUnidades;*/













































const mapaUnidades = () => {
  const selectedText = document.getElementById("selected-text");
  const optionsList = document.getElementById("custom-options");
  const estados = document.querySelectorAll(".estado");
  const statesRight = document.querySelectorAll(".ul-states li");
  const remotoButton = document.getElementById("remoto");
  const presencialButton = document.getElementById("presenciais");

  // Cards (apenas elementos que realmente são cards, possuem data-estado)
  const cards = document.querySelectorAll("#tipo-localizacao [data-estado]");
  // Seções de topo (presencial/remoto), exclui os cards
  const secoes = document.querySelectorAll("#tipo-localizacao [data-tipo]:not([data-estado])");

  const corRemoto = "#696969";
  const corPresencial = "#ccab78";

  // Estado do filtro
  let tipoAtual = "todos";
  let estadoAtual = null;

  // --------- Utilidades ---------
  const getEstadoFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const v = params.get("estado");
    return v ? v.toUpperCase() : null; // ex: "RJ"
  };

  // --------- Mapa (cores/estilos) ---------
  const aplicarEstilosPadrao = () => {
    estados.forEach((estado) => {
      const tipo = estado.dataset.tipo?.toLowerCase();
      estado.style.strokeWidth = "1.5px";
      estado.style.fill =
        tipo === "remoto"
          ? corRemoto
          : tipo === "presencial"
          ? corPresencial
          : "#000000";
      estado.style.display = "inline";
      estado.style.visibility = "visible";
      estado.style.opacity = "1";
    });
  };

  const atualizarStroke = (estado) => {
    if (estado.classList.contains("selected")) {
      estado.style.stroke = "#000000";
    } else {
      estado.style.stroke = "#ffffff";
    }
  };

  // Pinta o mapa por tipo (não mexe mais nos cards)
  const aplicarFiltroMapaPorTipo = (tipoSelecionado) => {
    estados.forEach((estado) => {
      const tipo = estado.dataset.tipo?.toLowerCase();

      // controla "selected" nos paths
      if (tipoSelecionado === "todos") {
        estado.classList.remove("selected");
        if (tipo === "remoto" || tipo === "presencial") {
          estado.classList.add("selected");
        }
      } else if (tipo === tipoSelecionado) {
        estado.classList.add("selected");
      } else {
        estado.classList.remove("selected");
      }

      // cores
      if (tipoSelecionado === "todos") {
        estado.style.fill =
          tipo === "remoto"
            ? corRemoto
            : tipo === "presencial"
            ? corPresencial
            : "#000000";
      } else if (tipo === tipoSelecionado) {
        estado.style.fill = tipoSelecionado === "remoto" ? corRemoto : corPresencial;
      } else {
        estado.style.fill = "#000000";
      }

      atualizarStroke(estado);

      estado.style.strokeWidth = "1.5px";
      estado.style.display = "inline";
      estado.style.visibility = "visible";
      estado.style.opacity = "1";
    });
  };

  // --------- Filtro COMBINADO (tipo + estado) NOS CARDS ---------
  const aplicarFiltroCombinado = () => {
    // conta visíveis por seção
    const visiveisPorSecao = new Map();
    secoes.forEach((secao) => visiveisPorSecao.set(secao, 0));

    cards.forEach((card) => {
      const estadoCard = (card.dataset.estado || "").toUpperCase(); // sigla
      const tipoCard = (card.dataset.tipo || "").toLowerCase();

      const passaEstado = !estadoAtual || estadoCard === estadoAtual;
      const passaTipo = tipoAtual === "todos" || tipoCard === tipoAtual;

      if (passaEstado && passaTipo) {
        card.classList.remove("hidden");
        const secao = card.closest("#tipo-localizacao [data-tipo]:not([data-estado])");
        if (secao) visiveisPorSecao.set(secao, (visiveisPorSecao.get(secao) || 0) + 1);
      } else {
        card.classList.add("hidden");
      }
    });

    // esconde/mostra as seções (presencial/remoto) se não houver card visível
    secoes.forEach((secao) => {
      const count = visiveisPorSecao.get(secao) || 0;
      secao.classList.toggle("hidden", count === 0);
    });
  };

  // --------- Dropdown personalizado (só adiciona listeners se existir) ---------
  if (selectedText && optionsList) {
    selectedText.addEventListener("click", () => {
      optionsList.classList.toggle("hidden");
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[js-select-wrapper]")) {
        optionsList.classList.add("hidden");
      }
    });

    optionsList.querySelectorAll("li").forEach((item) => {
     item.addEventListener("click", () => {
  const valor = item.dataset.value.toLowerCase(); // "todos" | "remoto" | "presencial"
  const label = selectedText.querySelector("p");
  if (label) label.textContent = item.textContent.trim();
  optionsList.classList.add("hidden");

  // atualiza estado do filtro
  tipoAtual = valor;
  aplicarFiltroMapaPorTipo(tipoAtual);
  aplicarFiltroCombinado();

  // --- redireciona se for "todos"
  if (valor === "todos") {
    window.location.href = "/unidades";
  }
});

    });
  }

  // --------- Clique nos estados do mapa → redireciona com a sigla ---------
// --------- Clique nos estados do mapa → redireciona e destaca ---------
estados.forEach((estado) => {
  // deixa o cursor de mãozinha
  estado.style.cursor = "pointer";

  estado.addEventListener("click", () => {
    let uf = estado.dataset.idEstado || "";
    uf = uf.toLowerCase();

    // converte nome → sigla ou usa direto
    const estadosMap = {
      acre: "AC", alagoas: "AL", amapa: "AP", amazonas: "AM",
      bahia: "BA", ceara: "CE", "distrito-federal": "DF", "espirito-santo": "ES",
      goias: "GO", maranhao: "MA", "mato-grosso": "MT", "mato-grosso-do-sul": "MS",
      "minas-gerais": "MG", para: "PA", paraiba: "PB", parana: "PR",
      pernambuco: "PE", piaui: "PI", "rio-de-janeiro": "RJ", "rio-grande-do-norte": "RN",
      "rio-grande-do-sul": "RS", rondonia: "RO", roraima: "RR", "santa-catarina": "SC",
      "sao-paulo": "SP", sergipe: "SE", tocantins: "TO"
    };

    uf = estadosMap[uf] || uf.toUpperCase();

    // 1) limpa os outros estados
    estados.forEach((e) => {
      e.classList.remove("selected");
      e.style.fill = "#000000"; // desliga cor (preto neutro, pode trocar p/ transparente se quiser)
    });

    // 2) marca este como selecionado e aplica a cor correta
    estado.classList.add("selected");
    const tipo = estado.dataset.tipo?.toLowerCase();
    if (tipo === "remoto") {
      estado.style.fill = corRemoto; // cinza
    } else if (tipo === "presencial") {
      estado.style.fill = corPresencial; // verde
    } else {
      estado.style.fill = "#000000";
    }

    // 3) redireciona
    if (uf) {
      window.location.href = `?estado=${uf}`;
    }
  });
});



  // --------- Hover no mapa ---------
  const changeStates = () => {
    estados.forEach((estado) => {
      estado.addEventListener("mouseenter", () => {
        estado.classList.add("active");

        statesRight.forEach((e) => {
          if (e.dataset.liEstado === estado.dataset.idEstado) {
            e.querySelector("p")?.classList.add("text-active");
            const svg = e.querySelector("svg");
            if (svg) {
              svg.classList.remove("opacity-0");
              svg.classList.add("opacity-1");
            }
          }
        });
      });

      estado.addEventListener("mouseleave", () => {
        estado.classList.remove("active");

        statesRight.forEach((e) => {
          e.querySelector("p")?.classList.remove("text-active");
          const svg = e.querySelector("svg");
          if (svg) svg.classList.add("opacity-0");
        });
      });
    });
  };

  // --------- Clique na lista lateral ---------
  const changeStatesActive = () => {
    statesRight.forEach((li) => {
      li.addEventListener("click", () => {
        statesRight.forEach((i) => {
          i.querySelector("p")?.classList.remove("text-active");
          i.querySelector("svg")?.classList.add("opacity-0");
        });

        li.querySelector("p")?.classList.add("text-active");
        li.querySelector("svg")?.classList.remove("opacity-0");
        li.querySelector("svg")?.classList.add("opacity-1");

        estados.forEach((e) => {
          if (li.dataset.liEstado === e.dataset.idEstado) {
            e.classList.add("active");
          } else {
            e.classList.remove("active");
          }
        });
      });
    });
  };

  // --------- Botões Remoto/Presencial ---------
  if (remotoButton) {
    remotoButton.addEventListener("click", () => {
      tipoAtual = "remoto";
      aplicarFiltroMapaPorTipo(tipoAtual);
      aplicarFiltroCombinado();
    });
  }

  if (presencialButton) {
    presencialButton.addEventListener("click", () => {
      tipoAtual = "presencial";
      aplicarFiltroMapaPorTipo(tipoAtual);
      aplicarFiltroCombinado();
    });
  }

  // --------- Inicialização ---------
  aplicarEstilosPadrao();
  changeStates();
  changeStatesActive();

  // lê estado da URL (sigla) e aplica
  estadoAtual = getEstadoFromUrl(); // ex.: "RJ" ou null
  tipoAtual = "todos";
  aplicarFiltroMapaPorTipo(tipoAtual);
  aplicarFiltroCombinado();
};

export default mapaUnidades;
